var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dx-scip-sales',{attrs:{"product-key":_vm.key,"variant-key":_vm.variantKey,"version-number":_vm.versionNumber,"contract-id":_vm.contractId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }